import { OrderCard, OrderCardProps } from '@ui/order/order-card';

export const OrdersList = ({
  items = [],
  isDivided = true,
}: {
  items?: (OrderCardProps | undefined)[];
  isDivided?: boolean;
}) => {
  return (
    <div className="flex flex-col lg:gap-y-6">
      {items.map((item, index) => (
        <div key={index}>
          <OrderCard {...item} />

          {index + 1 !== items?.length && isDivided && (
            <div className="bg-[#F8F9FA] h-2 -mx-4" />
          )}
        </div>
      ))}
    </div>
  );
};
